/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Badge, BadgeVariety } from '@sonarsource/echoes-react';
import { useIntl } from 'react-intl';

interface SlackIntegrationStatusBadgeProps {
  isBound: boolean;
}

export function SlackIntegrationStatusBadgge({
  isBound,
}: Readonly<SlackIntegrationStatusBadgeProps>) {
  const { formatMessage } = useIntl();

  const badgeVariety = isBound ? BadgeVariety.Info : BadgeVariety.Neutral;
  const badgeText = isBound
    ? formatMessage({ id: 'settings.slack.badge.configured' })
    : formatMessage({ id: 'settings.slack.badge.not_configured' });

  return <Badge variety={badgeVariety}>{badgeText}</Badge>;
}
